import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "multi-whitelabel__wrapper" }
const _hoisted_2 = { class: "multi-whitelabel__logo-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_MultiWhitelabelDialog = _resolveComponent("MultiWhitelabelDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.multiWhitelabelSlugList, (slug) => {
          return (_openBlock(), _createElementBlock("div", {
            key: slug,
            class: "multi-whitelabel__logo"
          }, [
            _createVNode(_component_el_image, {
              src: _ctx.getCdnUrl(slug),
              alt: `${slug}`,
              class: "multi-whitelabel__img"
            }, {
              error: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(slug), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["src", "alt"]),
            _createVNode(_component_el_icon, {
              class: "multi-whitelabel__img-close",
              onClick: ($event: any) => (_ctx.deleteWhitelabel(slug))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        icon: _ctx.icons.Plus,
        onClick: _ctx.openDialog
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Add whitelabel(-s) ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["icon", "onClick"])
    ]),
    _createVNode(_component_MultiWhitelabelDialog, {
      modelValue: _ctx.isMultiWhitelabelDialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isMultiWhitelabelDialogVisible) = $event)),
      selectedWhitelabelSlugList: _ctx.selectedWhitelabelSlugList,
      "onUpdate:selectedWhitelabelSlugList": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedWhitelabelSlugList) = $event)),
      onAddWhitelabel: _ctx.addWhitelabel
    }, null, 8 /* PROPS */, ["modelValue", "selectedWhitelabelSlugList", "onAddWhitelabel"])
  ], 64 /* STABLE_FRAGMENT */))
}